export const details =
{
    id: 1,
    titulo: "Jujutsu Kaisen 0: O Filme",
    img: "http://localhost:3000/capa.jpg",
    sinopse: "Infortúnios violentos ocorrem frequentemente em torno de Yuuta Okkotsu, de 16 anos, uma vítima tímida do bullying no ensino médio. Yuuta está sobrecarregado com uma maldição monstruosa, um poder que ensina vingança brutal contra seus agressores. Rika Orimoto, a maldição de Yuuta, é uma sombra de sua infância trágica e uma ameaça potencialmente letal para quem se atreve a errá-lo.A situação única de Yuuta chama a atenção de Satoru Gojou, um poderoso feiticeiro que ensina na Tokyo Jujutsu High. Gojou vê imenso potencial em Yuuta e espera ajudar o garoto a canalizar seu fardo mortal para uma força para o bem. No entanto, Yuuta luta para encontrar seu lugar entre seus talentosos colegas de classe: o seletivamente mudo Toge Inumaki, o especialista em armas Maki Zenin e Panda.",
    score: "8.49",
    tipo: "Filme",
    episodios: "1",
    lancamento: "24 de dezembro de 2021",
    Ano: "2021",
    produtores: "Sistema de Transmissão Mainichi, TOHO animação, Shueisha, Sumzap, Estúdio Páscoa",
    studio: "MAPPA",
    fonte: "Manga",
    demografia: "Shounen",
    duracao: "1hr.44min.",
    genero: {
        acao: "Ação",
        aventura: "Aventura",
        avantGarde: "Avant-garde",
        misterio: "Mistério",
        sobrenaturaç: "Sobrenatural",
        comedia: "Comédia",
        drama: "Drama",
        fanService: "Fan-Service",
        fantasia: "Fantasia",
        terror: "Terror",
        psicologico: "Psicológico",
        romance: "Romance",
        sciFi: "Sci-Fi",
        sliceOfLife: "Slice Of Life",
        sport: "Sport",
        seinen: "Seinen"
    }
}
export const detailsMangas = 
{
    id: 1,
    titulo: "Owari no Seraph",
    img: "http://localhost:3000/capaManga.jpg",
    sinopse: "Tendo perdido seus pais, Yuuichirou Amane, de oito anos, é acolhido pelo orfanato Hyakuya, onde luta para se relacionar com sua nova 'família'. No entanto, isso logo se torna a menor das suas preocupações, quando uma grande pandemia ocorre repentinamente, matando acima dos 13 anos. Aproveitando o caos, os vampiros — que anteriormente estavam adormecidos no subsolo — se levantam e escravizam os humanos sobreviventes, usando-os como gado para colher sangue. Quatro anos depois, Yuuichirou e sua família se adaptaram à vida sob controle de vampiros, embora Yuuichirou ainda aspire a matar todos os vampiros e acabar com seu reino de terror. Isso muitas vezes o coloca em desacordo com a colega órfã Mikaela Hyakuya, que enfatiza o uso de inteligência e engenhosidade para sobreviver. Tendo conquistado o favor entre vampiros de alto escalão, Mikaela ganha conhecimento interno e usa isso para planejar uma fuga ousada. Mas durante a tentativa, o grupo de órfãos é interceptado pelo oficial de vampiros Ferid Bathory, que começa a massacrá-los. Yuuichirou é o único membro do grupo a escapar para a superfície, onde é descoberto pela Moon Demon Company, uma unidade militar dedicada à caça de vampiros. Dado um convite para participar, Y",
    score: "8.49",
    lancamento: "03 de Setembro de 2012",
    Ano: "2012",
    autores: " Yamamoto, Yamato ( Art ), Kagami, Takaya ( História ), Furuya, Daisuke ( História )",
    studio: "Jump SQ",
    fonte: "Manga",
    demografia: "Shounen",
    volumes: "26",
    genero: {
        acao: "Ação",
        aventura: "Aventura",
        avantGarde: "Avant-garde",
        misterio: "Mistério",
        sobrenatural: "Sobrenatural",
        comedia: "Comédia",
        drama: "Drama",
        fanService: "Fan-Service",
        fantasia: "Fantasia",
        terror: "Terror",
        psicologico: "Psicológico",
        romance: "Romance",
        sciFi: "Sci-Fi",
        sliceOfLife: "Slice Of Life",
        sport: "Sport",
        seinen: "Seinen"
    }
}
